import gql from 'graphql-tag'

export const GET_PURCHASE = gql`
  query GetPurchase($purchaseId: ID!) {
    getPurchase(purchaseId: $purchaseId) {
      id
      orderId
      attendeeId
      orderItemId
      createdAt
      updatedAt
    }
  }
`
export const GET_EVENT_VISITOR_CITY_STATS = gql`
  query getEventVisitorCityStats($from: String!, $to: String!, $eventId: ID, $eventTemplateId: ID) {
    getEventVisitorCityStats(
      from: $from
      to: $to
      eventId: $eventId
      eventTemplateId: $eventTemplateId
    ) {
      cities {
        name
        total
      }
      primaryCity
      primaryCityPercentage
    }
  }
`
export const GET_EVENT_VISITORS_TRAFFIC_SOURCE_STATS = gql`
  query getEventVisitorTrafficSourceStats(
    $from: String!
    $to: String!
    $eventId: ID
    $eventTemplateId: ID
  ) {
    getEventVisitorTrafficSourceStats(
      from: $from
      to: $to
      eventId: $eventId
      eventTemplateId: $eventTemplateId
    ) {
      sources {
        name
        total
      }
      primaryTrafficSource
      primaryTrafficSourcePercentage
    }
  }
`

export const GET_EVENT_VISITOR_PAGE_VISIT_STATS = gql`
  query getEventVisitorPageVisitStats(
    $from: String!
    $to: String!
    $eventId: ID
    $eventTemplateId: ID
  ) {
    getEventVisitorPageVisitStats(
      from: $from
      to: $to
      eventId: $eventId
      eventTemplateId: $eventTemplateId
    ) {
      visits {
        date
        total
      }
      totalVisits
    }
  }
`

export const GET_EVENT_VISITOR_AGE_GENDER_STATS = gql`
  query getEventVisitorAgeGenderStats(
    $from: String!
    $to: String!
    $eventId: ID
    $eventTemplateId: ID
  ) {
    getEventVisitorAgeGenderStats(
      from: $from
      to: $to
      eventId: $eventId
      eventTemplateId: $eventTemplateId
    ) {
      male {
        age
        value
      }
      female {
        age
        value
      }
      totalMale
      totalFemale
    }
  }
`

export const GET_PURCHASE_BY_EVENT = gql`
  query GetPurchasesByEvent($eventId: ID!, $orderItemId: ID) {
    getPurchasesByEvent(eventId: $eventId, orderItemId: $orderItemId)
  }
`

export const GET_PURCHASE_BY_EVENT_2 = gql`
  query GetPurchasesByEvent2(
    $eventId: ID
    $eventTemplateId: ID
    $orderItemId: ID
    $ticketSellerId: ID
    $promoCodeIds: [ID!]!
    $saleChannelOnline: Boolean!
    $ticketsSoldFrom: String
    $ticketsSoldTo: String
    $earningsFrom: String
    $earningsTo: String
  ) {
    getPurchasesByEvent2(
      eventId: $eventId
      eventTemplateId: $eventTemplateId
      orderItemId: $orderItemId
      ticketSellerId: $ticketSellerId
      promoCodeIds: $promoCodeIds
      saleChannelOnline: $saleChannelOnline
      ticketsSoldFrom: $ticketsSoldFrom
      ticketsSoldTo: $ticketsSoldTo
      earningsFrom: $earningsFrom
      earningsTo: $earningsTo
    ) {
      eventTo
      totalEarnings
      totalPromoCodeEarnings
      totalTicketsSold
      totalTicketsReserved
      totalTicketsSoldWithPromoCode
      totalGratisTickets
      totalTicketsAvailable
      totalTicketsRefunded
      orderItems {
        id
        name
        initialQuantity
        itemMeta
        sectionSeats
      }
      ticketSellers {
        id
        name
      }
      promoCodes {
        id
        name
        discountType
        discountAmount
        ticketsPerOrder
        discountPercentage
        currency
      }
      ticketsSoldPerDay {
        date
        totalSold
        totalReserved
        ticketsPromo
        ticketsGratis
        promoCodes {
          id
          name
          count
        }
      }
      ticketsSoldPerPromoCode {
        id
        name
        discountType
        discountAmount
        currency
        discountPercentage
        sold
        unlimited
        initialQuantity
      }
      ticketsRevenuePerDay {
        date
        revenue
      }
      cumulativeTicketsRevenue {
        date
        revenue
      }
      soldTicketsGroupedByDayAndHour {
        e_dow
        e_hour
        numberOfTransactions
        numberOfSoldTickets
      }
      performances {
        id
        from
      }
      annualTicketsSold
    }
  }
`

export const GET_REFUNDED_PURCHASES_BY_EVENT = gql`
  query GetRefundedPurchasesByEvent(
    $eventId: ID
    $eventTemplateId: ID
    $orderItemId: ID
    $ticketSellerId: ID
    $promoCodeIds: [ID!]
    $saleChannelOnline: Boolean!
    $startDate: String!
    $endDate: String!
  ) {
    getRefundedPurchasesByEvent(
      eventId: $eventId
      eventTemplateId: $eventTemplateId
      orderItemId: $orderItemId
      ticketSellerId: $ticketSellerId
      promoCodeIds: $promoCodeIds
      saleChannelOnline: $saleChannelOnline
      startDate: $startDate
      endDate: $endDate
    ) {
      date
      totalRefunded
    }
  }
`

export const GET_TODAYS_SOLD_TICKETS_STATS = gql`
  query getTodaysSoldTicketsStats {
    getTodaysSoldTicketsStats
  }
`

export const GET_PURCHASE_SUMMARY = gql`
  query GetPurchaseSummary($eventId: ID!, $from: DateTime, $to: DateTime) {
    getPurchaseSummary(eventId: $eventId, from: $from, to: $to)
  }
`
export const GET_EVENT_LEGAL_ENTITY_INVOICES = gql`
  query GetEventLegalEntityInvoices($eventId: ID!) {
    getEventLegalEntityInvoices(eventId: $eventId)
  }
`
export const GET_EVENT_INVOICES_CATEGORIZED = gql`
  query GetEventInvoicesCountCategorized($eventId: ID!) {
    getEventInvoicesCountCategorized(eventId: $eventId)
  }
`

export const GET_THEATER_EVENT_REPORT = gql`
  query GetTheaterEventReport($eventId: ID!) {
    getTheaterEventReport(eventId: $eventId)
  }
`

export const GET_EVENT_ENTRY_STATS = gql`
  query getEventEntryStats($eventId: ID, $eventTemplateId: ID) {
    getEventEntryStats(eventId: $eventId, eventTemplateId: $eventTemplateId) {
      tickets {
        name
        total
        scanned
      }
      totalTicketsScanned
      totalTicketsSold
    }
  }
`

export const CREATE_PURCHASE = gql`
  mutation CreatePurchase($orderId: ID!, $attendeeId: ID!, $orderItemId: ID!) {
    createPurchase(orderId: $orderId, attendeeId: $attendeeId, orderItemId: $orderItemId) {
      id
      orderId
      attendeeId
      orderItemId
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_PURCHASE = gql`
  mutation UpdatePurchase($orderId: ID!) {
    updatePurchase(orderId: $orderId) {
      id
      orderId
      attendeeId
      orderItemId
      createdAt
      updatedAt
    }
  }
`

export const DELETE_PURCHASE = gql`
  mutation DeletePurchase($orderId: ID!) {
    deletePurchase(orderId: $orderId)
  }
`
